import React from 'react'
import {Box, Typography} from '@material-ui/core'
import {useStyles} from './bookclosure-tab-label-styles'
import CONSTANTS from '../../../utils/constants';

const {
  FDM_DASHBOARD: {
    TAB_CONFIGS: {  BOOKCLOSURE },
  },
} = CONSTANTS;
export function BookClosureTabLabel() {
    const styles = useStyles()
    const {
  FDM_DASHBOARD: {
    TAB_CONFIGS: {  BOOKCLOSURE },
  },
} = CONSTANTS;
    return (
        <Box className={styles.bookClosureTabContainer}>
            <Typography className={`${styles.tabLabelTypography} ${styles.tabLabelColor}`}>
                {BOOKCLOSURE.label}
            </Typography>
            <div className={styles.chipStyleBeta}>
                <Typography className={styles.betaLabelTypography}>BETA</Typography>
            </div>
        </Box>
    )
}